module.exports = __webpack_public_path__ + "static/img/icons.1e67f23.svg";


//////////////////
// WEBPACK FOOTER
// ./autocomplete-component/dist/src/fonts/icons.svg
// module id = Q4ZN
// module chunks = 1